// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const loginCenterJa = {
  pageTitle: "{platformName} プラットフォーム管理ログイン",
  eyebrow: "AIRange Control Plane",
  summary:
    "プラットフォーム管理系ワークスペースは、まず統合認証の現在セッションを引き継いでから対象コントロールプレーンへ入ります。",
  badgePlatform: "プラットフォーム管理",
  badgeSso: "統合認証",
  badgeLocalFallback: "ローカルアカウント",
  badgeMaintenance: "メンテナンス",
  badgeRunning: "稼働中",
  introEntryLabel: "現在の入口",
  introEntryValue: "プラットフォーム管理入口",
  introEntryHint:
    "問題・試験用紙・試験などの業務操作は扱わず、プラットフォーム統治機能のみを扱います。",
  introBoundaryLabel: "権限境界",
  introBoundaryValue: "プラットフォーム管理者向け",
  introBoundaryHint: "プラットフォームロールと試験業務ロールは分離されています。",
  credentialSection: "ログイン資格情報",
  authSource: "ログイン方式",
  authSourceSso: "統合認証",
  authSourceLocal: "ローカルログイン",
  ssoAlert:
    "このログインは統合認証経路を使用します。ブラウザは sso-center に直接接続し、業務 API プロキシを経由しません。",
  usernamePlaceholder: "ユーザー名を入力",
  passwordPlaceholder: "パスワードを入力",
  captchaPlaceholder: "認証コードを入力",
  usernameRequired: "ユーザー名を入力してください",
  passwordRequired: "パスワードを入力してください",
  captchaRequired: "認証コードを入力してください",
  submit: "プラットフォーム管理へログイン",
  footerPrimary: "統合認証を優先",
  footerSecondary: "ローカルログインは許可済みの運用で利用できます",
  maintenanceNotice:
    "現在メンテナンスモードです。プラットフォーム管理は許可済みの担当者のみ利用できます。",
  noAccess: "このアカウントにはプラットフォーム管理へのアクセス権がありません。",
  mustChangePassword:
    "このアカウントは先にパスワード変更が必要です。先に試験管理側で更新してください。",
  captchaNeeded: "認証コードの入力が必要です。",
  oidcCallbackProcessing: "統合認証ログインのコールバックを処理しています...",
  oidcCallbackMissingParams: "統合認証コールバックに code/state パラメータがありません。",
  oidcCallbackFailed: "統合認証コールバックの処理に失敗しました。",
  oidcCallbackRuntimeConfigFailed: "統合認証コールバックのランタイム設定を読み取れませんでした。",
  oidcCallbackRetryLogin: "再ログイン",
  oidcFailedNotice:
    "統合認証ログインのコールバックに失敗しました。再度ログインを開始してください。",
} as const;
